module.exports = __webpack_public_path__ + "img/towers.4e36b347.jpg";